module.exports = __webpack_public_path__ + "static/img/about_02.a2c7837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/about_02.png
// module id = rS5P
// module chunks = 34